import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { createMenuSlice, MenuSlice } from 'store/menu.ts';
import { createColorModeSliceSlice, ColorModeSlice } from 'store/colorMode';
import { createOfflineModeSlice, OfflineModeSlice } from 'store/offlineMode';
import createSelectors from 'store/selectors.ts';
import { createFlowSlice, FlowSlice } from './flow.ts';
import { createWorkflowExecutionsSlice, WorkflowExecutionsSlice } from './workflowExecutions.ts';
import { createWorkflowsSlice, WorkflowsSlice } from './workflows.ts';
import { createErrorsSlice, ErrorsSlice } from './errors.ts';
import { createLogLevelFilterSlice, LogLevelFilterSlice } from './logLevelFilter.ts';

type Store = MenuSlice &
  ColorModeSlice &
  OfflineModeSlice &
  FlowSlice &
  WorkflowExecutionsSlice &
  WorkflowsSlice &
  ErrorsSlice &
  LogLevelFilterSlice;

export const useStoreBase = create<Store>()(
  immer((...a) => ({
    ...createMenuSlice(...a),
    ...createColorModeSliceSlice(...a),
    ...createOfflineModeSlice(...a),
    ...createFlowSlice(...a),
    ...createWorkflowExecutionsSlice(...a),
    ...createWorkflowsSlice(...a),
    ...createErrorsSlice(...a),
    ...createLogLevelFilterSlice(...a),
  })),
);
export const useStore = createSelectors(useStoreBase);
